<template>
	<AppSubmenu class="layout-menu" :items="props.model" :layoutMode="props.layoutMode" :menuActive="props.active"
		:mobileMenuActive="props.mobileMenuActive" :root="true" :parentMenuItemActive="true" />
</template>

<script lang="ts" setup>

const props = defineProps<{
	model: any[],
	layoutMode: string | undefined,
	active: boolean,
	mobileMenuActive: boolean
}>()

</script>

<style scoped>

</style>
